module.exports = __webpack_public_path__ + "img/error.307d4ed6.svg";